import type { SVGProps } from "react";
import * as React from "react";
const SvgClaude = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#Claude_svg__a)">
      <path
        fill="#D97757"
        d="M0 4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Z"
      />
      <path
        fill="#FFF3EF"
        d="m6.532 14.967 3.54-1.986.06-.173-.06-.095H9.9l-.592-.037-2.023-.054-1.755-.073-1.7-.091-.428-.091L3 11.838l.041-.264.36-.241.515.045 1.14.078 1.708.118 1.24.073 1.836.191h.292l.04-.118-.1-.073-.077-.073-1.768-1.197L6.313 9.11 5.31 8.382l-.542-.369-.273-.346-.119-.756.492-.541.661.045.169.046.67.514 1.43 1.107 1.869 1.375.273.228.11-.078.013-.055-.123-.204-1.016-1.835-1.085-1.867-.483-.775-.127-.464a2.227 2.227 0 0 1-.078-.546l.56-.76.31-.101.748.1.315.273.464 1.061.752 1.671 1.167 2.273.342.674.182.623.068.192h.119v-.11l.095-1.28.178-1.57.173-2.022.06-.569.282-.683.56-.369.438.21.36.514-.05.333-.214 1.388-.42 2.177-.273 1.457h.16l.182-.182.738-.98 1.24-1.547.546-.615.638-.679.41-.323h.775l.57.847-.255.874-.798 1.011-.66.856-.948 1.275-.593 1.02.055.082.141-.013 2.142-.456 1.157-.21 1.381-.236.624.291.069.296-.246.606-1.477.364-1.731.346-2.58.61-.032.023.037.046 1.162.11.497.027h1.216l2.265.168.593.392.355.478-.06.364-.91.464-1.231-.291-2.87-.683-.985-.246h-.137v.082l.82.802 1.504 1.356 1.882 1.749.096.433-.242.341-.255-.036-1.654-1.243-.638-.56-1.445-1.216h-.095v.127l.332.487 1.76 2.641.09.81-.127.265-.456.16-.501-.092-1.03-1.443-1.062-1.626-.856-1.457-.105.06-.506 5.44-.237.279-.547.209-.456-.346-.241-.56.242-1.107.291-1.443.237-1.148.214-1.425.128-.473-.01-.032-.104.013-1.075 1.476-1.636 2.208-1.295 1.384-.31.123-.537-.277.05-.497.3-.441 1.792-2.277 1.08-1.412.697-.815-.005-.118h-.04L6.098 16.92l-.848.11-.364-.342.045-.56.173-.182 1.431-.984-.004.005Z"
      />
    </g>
    <defs>
      <clipPath id="Claude_svg__a">
        <rect width={24} height={24} fill="#fff" rx={4} />
      </clipPath>
    </defs>
  </svg>
);
export default SvgClaude;
